export default __webpack_public_path__ + "static/media/p19.1c2b817e.jpg";